'use client';

import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

import { useStoreCard } from './store-card-context';

export type NameProps = ComponentProps<'h3'>;

export function Name({ className, ...props }: NameProps) {
  const { store } = useStoreCard();

  return (
    <h3
      className={twMerge(
        'w-full overflow-hidden !font-sans font-normal overflow-ellipsis !whitespace-nowrap',
        className,
      )}
      {...props}
    >
      {store.name}
    </h3>
  );
}
